import type { LocaleCode } from "@/services/i18n";

export const getDeepTranslationsFilter = (code: LocaleCode) => ({
  translations: {
    _filter: {
      languages_code: { _eq: code },
    },
  },
});

export const getDeepBlocksFilter = (code: LocaleCode) => ({
  blocks: {
    item: {
      _filter: {
        status: { _eq: "published" }, // TODO - filtering by status published not works; its invalid code; to fix;
      },
      block: {
        item: getDeepTranslationsFilter(code),
      },
    },
  },
});
